import { css } from '@emotion/react';
import dayjs from 'dayjs';
import { Text } from '@frontend/design-system';

type AdaptiveTimeLabelProps = {
  startTime?: string;
  className?: string;
};

export const AdaptiveTimeLabel = ({ startTime, className }: AdaptiveTimeLabelProps) => {
  if (!startTime) return null;

  const d = dayjs(startTime);
  if (!d.isValid()) return null;

  const now = dayjs();
  const isToday = d.isSame(now, 'day');
  const isYesterday = d.isSame(now.subtract(1, 'day'), 'day');

  const timePart = d.format('h:mm A');

  let label: string;
  if (isToday) {
    label = `Today, ${timePart}`;
  } else if (isYesterday) {
    label = `Yesterday, ${timePart}`;
  } else {
    const datePart = d.isSame(now, 'year') ? d.format('MMM D') : d.format('MMM D, YYYY');
    label = `${datePart}, ${timePart}`;
  }

  return (
    <Text size='small' color='subdued' className={className} css={styles.timeText}>
      {label}
    </Text>
  );
};

const styles = {
  timeText: css`
    white-space: nowrap;
  `,
};
